module.exports = __webpack_public_path__ + "static/media/yellow-bottom.d5550390.svg";